export enum OnDuplicate {
    Fail = 'fail',
    Skip = 'skip',
    Overwrite = 'overwrite',
}
